export default __webpack_public_path__ + "static/media/chat-app.3bdfeb7b.jpeg";